import requests from "./httpService";



const BookingServices = {
  getAllBookings: async (body) => {
    return requests.post(`/client/upComingArrivals/${body}`);
  },

  getAddon: async () => {
    return requests.get(`/addons`);
  },

  getFilterBookings: async (id, body) => {
    return requests.post(`/client/upComingArrivals/${id}`, body);
  },

  cancelBooking: async (bookingId, body) => {
    return requests.post(`/client/cancel/${bookingId}`, body);
  },
  cancelOfflineBooking: async (bookingId, body) => {
    return requests.post(`/client/offlineCancellation/${bookingId}`, body);
  },

  getBookingsById: async (agentId, bookingId) => {
    return requests.get(`/client/getbookingid/${agentId}/${bookingId}`);
  },

  addBookings: async (id, body) => {
    return requests.post(`/client/add/${id}`, body);
  },
  emailSend: async (id, body) => {
    return requests.post(`/booking/sendEmailInvoice/${id}`, body);
  },
  itineraryEmailSend: async (id, body) => {
    return requests.post(`/booking/sendEmailItinerary/${id}`, body);
  },

  updateBookings: async (eid, id, body) => {
    return requests.put(`/client/update/${eid}/${id}`, body);
  },

  Updatearrivals: async (id, body) => {
    return requests.put(`/client/arrival-update/${id}`, body);
  },
  getAllExecutive: async (id) => {
    return requests.get(`/client/getAllExecutive/${id}`);
  },

  Assignexecutive: async (client_id, type, body) => {
    return requests.put(`/client/assign-executive/${client_id}/${type}`, body);
  },
  sendClientSms: async (id, body) => {
    return requests.post(`/client/sendClientSMS/${id}`, body);
  },
  sendDriverSms: async (id, body) => {
    return requests.post(`/driver/sendDriverSMS/${id}`, body);
  },
};

export default BookingServices;
